<app-header></app-header>

<!-- content -->
<section class="fullscreen error-block">

	<!-- start-section -->
	<div class="error-block__bkg">
		<div class="content">
			<div class="column-6 error-message">
				<h1 class="text-h1 text-h1--error">
					Oops!
					<div class="title-word">Error 404</div>
				</h1>
				<h2 class="text-h2">AQUÍ HAY ALGO RARO…</h2>
					<div class="error-block__button btn--error">
					<a class="btn" alt="Digital Boost" routerLink="">Volver</a>
				</div>
			</div>
		</div>
	</div>
</section>

<app-footer></app-footer>
